import Phaser from 'phaser';
import type { BackgroundDefinition } from '@/types';
import { INTERNAL_HEIGHT, INTERNAL_WIDTH } from '@/game/config/GameConfig';
import { backgroundTextureKey } from '@/data/backgrounds';
import { ensureMotifTexture } from './motifIcons';

interface Floater {
  obj: Phaser.GameObjects.Image;
  speed: number;
  wrapSize: number;
}

/** Full-bleed AI-illustrated backdrop (see data/backgrounds.ts / ARCHITECTURE.md's
 * "Background art" section) with a handful of small themed icons animated on top
 * for a bit of life -- the static illustration alone would otherwise never move.
 * Purely cosmetic -- gameplay never reads anything from this class. */
export class Background extends Phaser.GameObjects.Container {
  private icons: Floater[] = [];

  constructor(scene: Phaser.Scene, def: BackgroundDefinition) {
    super(scene, 0, 0);
    scene.add.existing(this);
    this.setDepth(-100);

    const backdrop = scene.add.image(INTERNAL_WIDTH / 2, INTERNAL_HEIGHT / 2, backgroundTextureKey(def.id));
    backdrop.setDisplaySize(INTERNAL_WIDTH, INTERNAL_HEIGHT);
    this.add(backdrop);

    if (def.motif !== 'none') {
      const textureKey = ensureMotifTexture(scene, def.motif, def.motifColor, def.motifColor2);
      const iconCount = 4;
      for (let i = 0; i < iconCount; i++) {
        const size = 30 + Math.random() * 18;
        const x = Math.random() * INTERNAL_WIDTH;
        const y = Math.random() * INTERNAL_HEIGHT;
        const icon = scene.add.image(x, y, textureKey);
        icon.setDisplaySize(size, size);
        icon.setAlpha(0.55 + Math.random() * 0.25);
        icon.setRotation(Math.random() * Math.PI * 2);
        this.add(icon);
        this.icons.push({ obj: icon, speed: 8 + Math.random() * 14, wrapSize: size });
      }
    }
  }

  update(deltaSeconds: number): void {
    for (const icon of this.icons) {
      icon.obj.y -= icon.speed * deltaSeconds;
      icon.obj.rotation += deltaSeconds * 0.3;
      if (icon.obj.y < -icon.wrapSize) {
        icon.obj.y = INTERNAL_HEIGHT + icon.wrapSize;
        icon.obj.x = Math.random() * INTERNAL_WIDTH;
      }
    }
  }
}
